/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    HowToClaim: {
        id: 'cep.claimsPage.HowToClaim',
        defaultMessage: 'How to claim'
    },
    ReadMoreButtonLabel: {
        id: 'cep.claimsPage.ReadMoreButtonLabel',
        defaultMessage: 'Read more'
    },
    Or: {
        id: 'cep.claimsPage.Or',
        defaultMessage: 'Or'
    },
    // Motor section - start
    MotorClaims: {
        id: 'cep.claimsPage.MotorClaims',
        defaultMessage: 'Motor claims'
    },
    MotorClaimsBaseInfoP1: {
        id: 'cep.claimsPage.MotorClaimsInfoP1',
        defaultMessage: 'If you need to make a claim, please call our claims assistance number on {phoneNumber}, so we can deal with your claim as soon as possible. If another party was involved in the accident/incident, regardless of fault, there\'s no need for you to deal with them (or their insurer) - give them our details and let us deal with everything for you. If you can, please try to obtain the contact and insurance details of any other involved parties.'
    },
    MotorClaimsBaseInfoP2: {
        id: 'cep.claimsPage.MotorClaimsInfoP2',
        defaultMessage: 'If you need to make a claim to repair or replace damaged glass call us on {phoneNumber1}, so we can deal with your glass claim as soon as possible. For Saga standard customers please call us on {phoneNumber2}.'
    },
    MotorClaimsBaseInfoP3: {
        id: 'cep.claimsPage.MotorClaimsBaseInfoP3',
        defaultMessage: 'The speed with which you report the claim helps us protect your interests so please call us as soon as you safely can. You can report your claim to us 24/7.'
    },
    MotorClaimsNextSteps: {
        id: 'cep.claimsPage.MotorClaimsNextSteps',
        defaultMessage: 'The next steps'
    },
    MotorClaimsNextStepsP1: {
        id: 'cep.claimsPage.MotorClaimsNextStepsP1',
        defaultMessage: 'We want to make your claim experience as easy as we can. So that you know just where you are in the process, there are five steps we follow, from you picking up the phone to being back on the road.'
    },
    MotorNextStepsBullet1: {
        id: 'cep.claimsPage.MotorNextStepsBullet1',
        defaultMessage: '<b>Phone</b> - Call us and let one of our friendly claims experts take care of your claim.'
    },
    MotorNextStepsBullet2: {
        id: 'cep.claimsPage.MotorNextStepsBullet2',
        defaultMessage: '<b>Garage</b> - We\'ll get your vehicle into one of our approved garages as soon as we can.'
    },
    MotorNextStepsBullet3: {
        id: 'cep.claimsPage.MotorNextStepsBullet3',
        defaultMessage: '<b>Replacement car</b> - We\'ll also get you a replacement car to keep you on the road while we repair yours.'
    },
    MotorNextStepsBullet4: {
        id: 'cep.claimsPage.MotorNextStepsBullet4',
        defaultMessage: '<b>Repair</b> - Your car will be repaired with guaranteed parts and the work is guaranteed for five years. If repair isn\'t possible, we\'ll pay you the full market value for your car, and in some cases, we can even replace it with a new one.'
    },
    MotorNextStepsBullet5: {
        id: 'cep.claimsPage.MotorNextStepsBullet5',
        defaultMessage: '<b>Back on the road</b> - We\'ll have you back on the road, leaving our claims experts to deal with any outstanding parts of your claim. If we need any more information after you\'re back behind the wheel, we will be in touch.'
    },
    MotorContactUs: {
        id: 'cep.claimsPage.MotorContactUs',
        defaultMessage: 'Contact Us'
    },
    MotorContactUsP1: {
        id: 'cep.claimsPage.MotorContactUsP1',
        defaultMessage: 'For all claims queries please call us on {phoneNumber}'
    },
    MotorContactUsP2: {
        id: 'cep.claimsPage.MotorContactUsP2',
        defaultMessage: 'To repair or replace damaged glass call us on {phoneNumber}'
    },
    MotorContactUsP3: {
        id: 'cep.claimsPage.MotorContactUsP3',
        defaultMessage: 'If you have a question, you could find the answer right here…'
    },
    // Motor accordions
    LiabilityHeader: {
        id: 'cep.claimsPage.LiabilityHeader',
        defaultMessage: 'Liability'
    },
    LiabilityContent: {
        id: 'cep.claimsPage.LiabilityContent',
        defaultMessage: 'To settle the liability aspect of your claim we will make contact with the third party insurer on your behalf. We may request more information from you as your claim progresses, but we will aim to reach a decision with the other insurer about who was at fault as soon as possible based on all the evidence we have been provided with.'
    },
    RepairsHeader: {
        id: 'cep.claimsPage.RepairsHeader',
        defaultMessage: 'Repairs'
    },
    RepairsContent: {
        id: 'cep.claimsPage.RepairsContent',
        defaultMessage: 'We will monitor the progress of your repair for you and will keep you updated while your car is being fixed. We\'ll be in contact as soon as your car is ready to be returned to you. Also, when you use one of our approved garages the work completed is guaranteed and won\'t affect any warranty that you may have. '
    },
    HireCarHeader: {
        id: 'cep.claimsPage.HireCarHeader',
        defaultMessage: 'Hire car'
    },
    HireCarContent: {
        id: 'cep.claimsPage.HireCarContent',
        defaultMessage: 'If you\'re involved in an incident and your car is taken to one of our approved repairers, we will provide you with a car to keep you mobile, either through our network of garages or by arranging a car through another supplier. We aim to keep you on the road.  If your car is stolen or declared a total loss, we can only provide a replacement if you have elected to take the additional replacement car cover. Of course, we will aim to get your claim settled as soon as possible.'
    },
    TotalLossHeader: {
        id: 'cep.claimsPage.TotalLossHeader',
        defaultMessage: 'Total loss'
    },
    TotalLossContent: {
        id: 'cep.claimsPage.TotalLossContent',
        defaultMessage: 'If your car can\'t be repaired or is stolen and not recovered, we will pay you the market value to allow you to replace it. We calculate the market value by consulting specialist engineers, who use all the relevant information about your car to give us its true value.  If your car is less than two years old, however, you may qualify for our \'New Vehicle Benefit\', which means we will source a brand new car, of the same type and specification where possible, to replace your old one.'
    },
    FireTheftHeader: {
        id: 'cep.claimsPage.FireTheftHeader',
        defaultMessage: 'Fire, theft and vandalism'
    },
    FireTheftContent: {
        id: 'cep.claimsPage.FireTheftContent',
        defaultMessage: 'If your car is damaged by fire, theft or vandalism, you should report the incident to the police as soon as you can. They should provide you with an incident or crime number, which you should give to us as soon as you have it.  When you have done this, we will arrange to repair your car or pay you the market value, depending on the nature of the incident and the damage that has been caused.'
    },
    PersonalBelongingsHeader: {
        id: 'cep.claimsPage.PersonalBelongingsHeader',
        defaultMessage: 'Personal belongings'
    },
    PersonalBelongingsContent: {
        id: 'cep.claimsPage.PersonalBelongingsContent',
        defaultMessage: 'If you have lost personal belongings in the incident, you can send details of what has been lost to us; including a description of each item, its age, value and, where possible, any evidence to support your claim, such as receipts.  We will aim to settle your claim as soon as possible taking into account your insurance policy limits.'
    },
    PersonalInjuryHeader: {
        id: 'cep.claimsPage.PersonalInjuryHeader',
        defaultMessage: 'Personal injury'
    },
    PersonalInjuryContent: {
        id: 'cep.claimsPage.PersonalInjuryContent',
        defaultMessage: 'If you were injured in the incident and it wasn\'t your fault, you have the right to claim for your injuries from the at fault party. If you have legal cover we will instruct our preferred solicitors to assist you. They will contact you to discuss the injury and offer assistance where possible to make sure you are taken care of. If you don\'t have legal cover, we can either provide details of our Business Partners who are able to assist, or provide you with details on how to find an appropriate solicitor through the Solicitors Regulation Authority.'
    },
    MotorExcessHeader: {
        id: 'cep.claimsPage.MotorExcessHeader',
        defaultMessage: 'Excess'
    },
    MotorExcessContent: {
        id: 'cep.claimsPage.MotorExcessContent',
        defaultMessage: 'Your excess is the amount you pay towards your claim. You will have agreed your excess amount when arranging your insurance policy. Your excess will need to be paid in all incidents where you are making a  claim for damage and you were deemed to be at fault. For non-fault incidents you can claim your excess back from the other party. If you have legal cover we can help you do this, and where you don\'t have legal cover we will supply you with the details of the other insurer to allow you to claim your excess back'
    },
    // Motor section - end
    // Home section - start
    HomeClaims: {
        id: 'cep.claimsPage.HomeClaims',
        defaultMessage: 'Home claims'
    },
    HomeClaimsBaseInfoP1: {
        id: 'cep.claimsPage.HomeClaimsBaseInfoP1',
        defaultMessage: 'Click \'Read more\' for step-by-step details to guide you through the process of making a claim.'
    },
    HomeStep1Header: {
        id: 'cep.claimsPage.HomeStep1Header',
        defaultMessage: 'Step 1: Check that you\'re covered'
    },
    HomeStep1P1: {
        id: 'cep.claimsPage.HomeStep1P1',
        defaultMessage: 'Before calling us, please check your policy documents to make sure you\'re covered. If you took out your policy online and received email confirmation, you can log in to MySaga to access your documents.'
    },
    HomeStep1P2: {
        id: 'cep.claimsPage.HomeStep1P2',
        defaultMessage: 'Your policy Schedule will specify whether you have buildings insurance, contents insurance or both. Your policy documents will also specify the excess you have to pay when making a claim. If your claim is for both your buildings and contents, you will pay both excesses listed in the documents.'
    },
    HomeStep1P3: {
        id: 'cep.claimsPage.HomeStep1P3',
        defaultMessage: '<b>Please note:</b> There are times where we are unable to cover part or all of your claim, due to the fact that you do not have the necessary level of policy cover or that the damage is not something we can cover at all, e.g. if it has happened gradually over time.'
    },
    HomeStep2Header: {
        id: 'cep.claimsPage.HomeStep2Header',
        defaultMessage: 'Step 2: Find your details'
    },
    HomeStep2P1: {
        id: 'cep.claimsPage.HomeStep2P1',
        defaultMessage: 'The following details are designed to give you some guidance on what happens when you make a claim and the steps involved from when you first pick up the phone to register a claim with us, to getting it all settled and how we will be closely involved every step of the way.'
    },
    HomeStep2P2: {
        id: 'cep.claimsPage.HomeStep2P2',
        defaultMessage: 'You need to call us to let us know you need to make a claim. At this point, we will ask you to confirm certain details, just so we can ensure we are dealing with the correct person and policy.'
    },
    HomeStep2P3: {
        id: 'cep.claimsPage.HomeStep2P3',
        defaultMessage: 'After taking the details of your claim we will confirm whether your policy covers the loss or damage in principle. If it does, we\'ll continue to step three below.'
    },
    HomeStep3Header: {
        id: 'cep.claimsPage.HomeStep3Header',
        defaultMessage: 'Step 3: What will happen next'
    },
    HomeStep3P1: {
        id: 'cep.claimsPage.HomeStep3P1',
        defaultMessage: 'Depending on the type of claim you\'re making, there are various ways we might handle it.'
    },
    HomeStep3P2: {
        id: 'cep.claimsPage.HomeStep3P2',
        defaultMessage: 'We will review your claim and if it is for minor damage, we may require further documentation to be sent in by post or email. This could include items like estimates or photographs.'
    },
    HomeStep3P3: {
        id: 'cep.claimsPage.HomeStep3P3',
        defaultMessage: 'Upon receipt of the requested documents, we will review and contact you to give you an update or an outcome of the claim, which could be one of the following:'
    },
    HomeStep3P4: {
        id: 'cep.claimsPage.HomeStep3P4',
        defaultMessage: 'Agree settlement of your claim. This could be by replacing the item(s) with new ones, or paying you the cash value.'
    },
    HomeStep3P5: {
        id: 'cep.claimsPage.HomeStep3P5',
        defaultMessage: 'Request further information, which we will discuss with you and then keep you updated on how your claim is progressing'
    },
    HomeStep3P6: {
        id: 'cep.claimsPage.HomeStep3P6',
        defaultMessage: 'Pass it on to one of our nominated suppliers, who will assist us and you in settling the claim. This normally happens with high value or complex claims like subsidence or flooding.'
    },
    HomeStep3P7: {
        id: 'cep.claimsPage.HomeStep3P7',
        defaultMessage: 'Please note: If you have a joint buildings and contents claim, the same procedure as above will be followed depending on the complexity of your claim.'
    },
    AdditionalInformation: {
        id: 'cep.claimsPage.AdditionalInformation',
        defaultMessage: 'Additional Information'
    },
    HelpPrevent: {
        id: 'cep.claimsPage.HelpPrevent',
        defaultMessage: 'Help prevent a claim'
    },
    InsideHome: {
        id: 'cep.claimsPage.InsideHome',
        defaultMessage: 'Inside the home'
    },
    OutsideHome: {
        id: 'cep.claimsPage.OutsideHome',
        defaultMessage: 'Outside the home'
    },
    VisualCheck: {
        id: 'cep.claimsPage.VisualCheck',
        defaultMessage: 'A visual check should be carried out to the following:'
    },
    // Home accordions
    SuppliersHeader: {
        id: 'cep.claimsPage.SuppliersHeader',
        defaultMessage: 'What are Suppliers / Loss Adjusters?'
    },
    SuppliersContent1: {
        id: 'cep.claimsPage.SuppliersContent1',
        defaultMessage: 'If your claim has been passed to one of our suppliers, here are some useful points that you might like to know'
    },
    SuppliersContent2: {
        id: 'cep.claimsPage.SuppliersContent2',
        defaultMessage: 'A supplier will be used to help us review your claim and may contact you to discuss it further'
    },
    SuppliersContent3: {
        id: 'cep.claimsPage.SuppliersContent3',
        defaultMessage: 'In the event of a large loss or complex claim for example a house fire, your insurer may appoint a loss adjuster to help you through the claim journey'
    },
    HomeExcessHeader: {
        id: 'cep.claimsPage.HomeExcessHeader',
        defaultMessage: 'What\'s an excess?'
    },
    HomeExcessContent1: {
        id: 'cep.claimsPage.HomeExcessContent1',
        defaultMessage: 'Your excess is the amount you pay towards your claim. You will have agreed your excess amount when arranging your insurance policy'
    },
    HomeExcessContent2: {
        id: 'cep.claimsPage.HomeExcessContent2',
        defaultMessage: 'Please refer to your policy documents for further details of your own specific excesses.'
    },
    HomeExcessContent3: {
        id: 'cep.claimsPage.HomeExcessContent3',
        defaultMessage: 'There are separate excesses that apply under both the buildings and contents policies'
    },
    HomeExcessContent4: {
        id: 'cep.claimsPage.HomeExcessContent4',
        defaultMessage: 'These will either be payable to our nominated suppliers or deducted from settlement payments.'
    },
    InsurerPartnersHeader: {
        id: 'cep.claimsPage.InsurerPartnersHeader',
        defaultMessage: 'What are Insurer Partners?'
    },
    InsurerPartnersContent1: {
        id: 'cep.claimsPage.InsurerPartnersContent1',
        defaultMessage: 'Depending on your Insurance policy, you may have different Insurers for your joint Building and Contents policy with Saga.'
    },
    InsurerPartnersContent2: {
        id: 'cep.claimsPage.InsurerPartnersContent2',
        defaultMessage: 'This may mean if you are making a claim under both sections of your policy, you will deal with both Insurers who will oversee your claim.'
    },
    BuildingOrContentsHeader: {
        id: 'cep.claimsPage.BuildingOrContentsHeader',
        defaultMessage: 'Is it a buildings claim or a contents claim?'
    },
    BuildingOrContentsContent1: {
        id: 'cep.claimsPage.BuildingOrContentsContent1',
        defaultMessage: 'Buildings claims can be made for damage to structural elements in your home, such as the roof, floors and walls.'
    },
    BuildingOrContentsContent2: {
        id: 'cep.claimsPage.BuildingOrContentsContent2',
        defaultMessage: 'Contents claims can be made too for those items within the household which are not part of the building itself, such as your furniture. Depending on the insurance you have taken with us, it may also include items of jewellery or clothing'
    },
    BeforeYouCallHeader: {
        id: 'cep.claimsPage.BeforeYouCallHeader',
        defaultMessage: 'Before you call us to make your claim, check your policy schedule to see if you are covered for either buildings, contents or combined insurance'
    },
    BeforeYouCallContent1: {
        id: 'cep.claimsPage.BeforeYouCallContent1',
        defaultMessage: 'When you contact us we will review your claim and if it is for minor damage we may require further documentation such as estimates or photographs to be sent in by post or email.'
    },
    BeforeYouCallContent2: {
        id: 'cep.claimsPage.BeforeYouCallContent2',
        defaultMessage: 'Upon receipt of the requested documents, we will review and contact you to give you an update or an outcome of the claim. We might:'
    },
    BeforeYouCallContent3: {
        id: 'cep.claimsPage.BeforeYouCallContent3',
        defaultMessage: 'Agree payment over the telephone'
    },
    BeforeYouCallContent4: {
        id: 'cep.claimsPage.BeforeYouCallContent4',
        defaultMessage: 'Request further information which we will discuss with you and update you on your claim'
    },
    BeforeYouCallContent5: {
        id: 'cep.claimsPage.BeforeYouCallContent5',
        defaultMessage: 'Pass your claim to one of our nominated suppliers to deal with (this usually happens at this stage because the value or complexity of the claim is such that we feel a supplier is needed to assist us and you in settling the claim)'
    },
    BeforeYouCallContent6: {
        id: 'cep.claimsPage.BeforeYouCallContent6',
        defaultMessage: 'Please note, in the event that your claim is of a complex nature or you\'ve experienced significant damage i.e. fire/flood, our fully qualified and experienced suppliers will be immediately instructed to help deal with repairs and replacement of items.'
    },
    WhatYouAskHeader: {
        id: 'cep.claimsPage.WhatYouAskHeader',
        defaultMessage: 'What will you ask me when I call?'
    },
    WhatYouAskContent1: {
        id: 'cep.claimsPage.WhatYouAskContent1',
        defaultMessage: 'When you give us a call, it will help if you can provide us with your name, address and policy number.'
    },
    WhatYouAskContent2: {
        id: 'cep.claimsPage.WhatYouAskContent2',
        defaultMessage: 'We will then ask you for'
    },
    WhatYouAskContent3: {
        id: 'cep.claimsPage.WhatYouAskContent3',
        defaultMessage: 'The circumstances surrounding your claim'
    },
    WhatYouAskContent4: {
        id: 'cep.claimsPage.WhatYouAskContent4',
        defaultMessage: 'Information about what you are claiming for'
    },
    WhatYouAskContent5: {
        id: 'cep.claimsPage.WhatYouAskContent5',
        defaultMessage: 'We may then ask you to send us'
    },
    WhatYouAskContent6: {
        id: 'cep.claimsPage.WhatYouAskContent6',
        defaultMessage: 'Photographs'
    },
    WhatYouAskContent7: {
        id: 'cep.claimsPage.WhatYouAskContent7',
        defaultMessage: 'Receipts and valuations for items you have purchased'
    },
    WhatYouAskContent8: {
        id: 'cep.claimsPage.WhatYouAskContent8',
        defaultMessage: 'Estimates for repairs'
    },
    WhatYouAskContent9: {
        id: 'cep.claimsPage.WhatYouAskContent9',
        defaultMessage: 'Other documentary evidence'
    },
    WhatNotCoveredHeader: {
        id: 'cep.claimsPage.WhatNotCoveredHeader',
        defaultMessage: 'What wouldn\'t normally be covered?'
    },
    WhatNotCoveredContent1: {
        id: 'cep.claimsPage.WhatNotCoveredContent1',
        defaultMessage: 'In case you were wondering, there are some elements that not covered by your insurance policy, and some examples are below'
    },
    WhatNotCoveredContent2: {
        id: 'cep.claimsPage.WhatNotCoveredContent2',
        defaultMessage: 'Breakdown and maintenance of items such as boilers'
    },
    WhatNotCoveredContent3: {
        id: 'cep.claimsPage.WhatNotCoveredContent3',
        defaultMessage: 'Wear and tear or gradually operating causes'
    },
    WhatNotCoveredContent4: {
        id: 'cep.claimsPage.WhatNotCoveredContent4',
        defaultMessage: 'Mechanical and Electrical failure of appliances'
    },
    WhatNotCoveredContent5: {
        id: 'cep.claimsPage.WhatNotCoveredContent5',
        defaultMessage: 'For further details or more specific information on what is covered by your insurance, please check your policy booklet.'
    },
    LoftHeader: {
        id: 'cep.claimsPage.LoftHeader',
        defaultMessage: 'Loft'
    },
    LoftContent1: {
        id: 'cep.claimsPage.LoftContent1',
        defaultMessage: 'Take a torch up into the loft space and check the following:'
    },
    LoftContent2: {
        id: 'cep.claimsPage.LoftContent2',
        defaultMessage: 'Lagging'
    },
    LoftContent3: {
        id: 'cep.claimsPage.LoftContent3',
        defaultMessage: 'Make sure that all water tanks are lagged and that the lagging hasn\'t slipped over time, exposing the tank to the cold. The same goes for water pipes, these should be lagged, and no pipes exposed to the air- replace any that has slipped or is missing.'
    },
    LoftContent4: {
        id: 'cep.claimsPage.LoftContent4',
        defaultMessage: 'Damp'
    },
    LoftContent5: {
        id: 'cep.claimsPage.LoftContent5',
        defaultMessage: 'Look for any signs of dampness, particularly in areas where the roof slope changes such as ridges and valleys of the roof, around chimneys, and on brickwork to gable ends. If there are any signs - such as darker patches, water staining, white streaks of powdery residue - this could be a sign that rainwater has been entering the roof space and maintenance is required.'
    },
    LoftContent6: {
        id: 'cep.claimsPage.LoftContent6',
        defaultMessage: 'Daylight'
    },
    LoftContent7: {
        id: 'cep.claimsPage.LoftContent7',
        defaultMessage: 'Turn off the torch and if daylight can be seen coming through any part of the roof then there is a problem'
    },
    MainAreasHeader: {
        id: 'cep.claimsPage.MainAreasHeader',
        defaultMessage: 'Main living areas'
    },
    MainAreasContent1: {
        id: 'cep.claimsPage.MainAreasContent1',
        defaultMessage: 'Stop cock'
    },
    MainAreasContent2: {
        id: 'cep.claimsPage.MainAreasContent2',
        defaultMessage: 'Locate the mains water stop cock (usually under the kitchen sink) and make sure it can be turned on and off easily - if a pipe burst in the house, this would probably be the first thing to turn off.'
    },
    MainAreasContent3: {
        id: 'cep.claimsPage.MainAreasContent3',
        defaultMessage: 'Windows'
    },
    MainAreasContent4: {
        id: 'cep.claimsPage.MainAreasContent4',
        defaultMessage: 'Go around every window in the house and make sure it closes and seals properly. Look around the internal reveals for any signs of dampness as this could indicate that the sealant on the outside is failing'
    },
    MainAreasContent5: {
        id: 'cep.claimsPage.MainAreasContent5',
        defaultMessage: 'Doors'
    },
    MainAreasContent6: {
        id: 'cep.claimsPage.MainAreasContent6',
        defaultMessage: 'As for windows, check that external doors close and lock properly and check the reveals for any signs of damp. Always be careful when opening doors in high winds (especially doors that open outwards) as they can be damaged if the wind catches them unexpectedly.'
    },
    RoofHeader: {
        id: 'cep.claimsPage.RoofHeader',
        defaultMessage: 'Roof'
    },
    RoofContent1: {
        id: 'cep.claimsPage.RoofContent1',
        defaultMessage: 'Gutters'
    },
    RoofContent2: {
        id: 'cep.claimsPage.RoofContent2',
        defaultMessage: 'An overflowing gutter can cause lots of damp problems over time if it is not addressed.'
    },
    RoofContent3: {
        id: 'cep.claimsPage.RoofContent3',
        defaultMessage: 'Moss on roofs dries out in the summer and some can end up in the gutters. Leaves in autumn are also a major cause of gutters to block, so it is worth having gutters checked and unblocked at least once a year. Also, if there are no leaf guards, then downpipes can block too.'
    },
    RoofContent4: {
        id: 'cep.claimsPage.RoofContent4',
        defaultMessage: 'Also check that sections of gutter haven\'t come apart and that all the fixing brackets are intact and securely attached to the fascia boards. Plastic gutters are susceptible to “creep” due to the varying temperatures of the seasons and joints can come apart.'
    },
    RoofContent5: {
        id: 'cep.claimsPage.RoofContent5',
        defaultMessage: 'Facias and bargeboards'
    },
    RoofContent6: {
        id: 'cep.claimsPage.RoofContent6',
        defaultMessage: 'Traditionally these would have been timber and either painted or stained, but more recently, PVCu is the favoured material.'
    },
    RoofContent7: {
        id: 'cep.claimsPage.RoofContent7',
        defaultMessage: 'Generally, timber facias/bargeboards will need repainting/re-staining every five years - signs of wear and tear would be flaking paint and split/ rotten wood and if this is the case, then they will be susceptible to damage in high winds and any guttering fixed to them is likely to become loose.'
    },
    RoofContent8: {
        id: 'cep.claimsPage.RoofContent8',
        defaultMessage: 'If you have your fascia/bargeboards replaced, make sure that the new material is being fixed into sound wood and not existing rotten timber (this can be the case when old fascia is not removed but covered over).'
    },
    RoofContent9: {
        id: 'cep.claimsPage.RoofContent9',
        defaultMessage: 'Roof tiles'
    },
    RoofContent10: {
        id: 'cep.claimsPage.RoofContent10',
        defaultMessage: 'The most vulnerable areas of a roof to storm are where the wind is forced to change direction - these are normally the \'edges\' of the roof i.e. Ridges, hips and verges'
    },
    RoofContent11: {
        id: 'cep.claimsPage.RoofContent11',
        defaultMessage: 'Ridge tiles'
    },
    RoofContent12: {
        id: 'cep.claimsPage.RoofContent12',
        defaultMessage: 'These are normally curved and as the name suggests, sit on the top of the roof. Check that none are missing and that the mortar they are bedded on is in good condition (not cracked or crumbling)'
    },
    RoofContent13: {
        id: 'cep.claimsPage.RoofContent13',
        defaultMessage: 'Hips'
    },
    RoofContent14: {
        id: 'cep.claimsPage.RoofContent14',
        defaultMessage: 'These can be similar to either ridge tiles or they are bonnet tiles. They are found on the sloping joints between two roof profiles. As with ridge tiles, check that none are missing or have slipped and that the mortar is in good condition.'
    },
    RoofContent15: {
        id: 'cep.claimsPage.RoofContent15',
        defaultMessage: 'Verges'
    },
    RoofContent16: {
        id: 'cep.claimsPage.RoofContent16',
        defaultMessage: 'This is where the roof finishes as a straight edge- usually over a gable. Check that no tiles are missing, cracked or have slipped and that the mortar they are bedded on is in good condition.'
    },
    RoofContent17: {
        id: 'cep.claimsPage.RoofContent17',
        defaultMessage: 'Generally, on the roof, check that there are no missing, loose, cracked or slipped tiles.'
    },
    RoofContent18: {
        id: 'cep.claimsPage.RoofContent18',
        defaultMessage: 'Flat roofs'
    },
    RoofContent19: {
        id: 'cep.claimsPage.RoofContent19',
        defaultMessage: 'Flat roofs made from bituminous felt need regular checking as they are prone to leaks and water damage.'
    },
    RoofContent20: {
        id: 'cep.claimsPage.RoofContent20',
        defaultMessage: 'Things to check for are cracks, heat bubbles, pooling water, de-lamination and joints between the flat roof and walls. You may also want to ensure that the stone chippings (where relevant) have not become displaced as this can expose the felt to the elements, leading to damage. The general life expectancy of a felt flat roof is 10 years.'
    },
    LeadFlashingsHeader: {
        id: 'cep.claimsPage.LeadFlashingsHeader',
        defaultMessage: 'Lead flashings'
    },
    LeadFlashingsContent1: {
        id: 'cep.claimsPage.LeadFlashingsContent1',
        defaultMessage: 'Found around chimneys, above conservatory roofs and where roofs meet walls.'
    },
    LeadFlashingsContent2: {
        id: 'cep.claimsPage.LeadFlashingsContent2',
        defaultMessage: 'Check that there are no cracks in the lead, it hasn\'t slipped and the lead wedges and mortar joints holding it in place are intact and in good condition'
    },
    ChimneysHeader: {
        id: 'cep.claimsPage.ChimneysHeader',
        defaultMessage: 'Chimneys'
    },
    ChimneysContent: {
        id: 'cep.claimsPage.ChimneysContent',
        defaultMessage: 'The pots should be straight and the mortar holding them in place should also be in good condition. Check the mortar joints between the bricks - none should be missing, cracked or crumbling.'
    },
    WindowsDoorsHeader: {
        id: 'cep.claimsPage.WindowsDoorsHeader',
        defaultMessage: 'Windows and Doors'
    },
    WindowsDoorsContent: {
        id: 'cep.claimsPage.WindowsDoorsContent',
        defaultMessage: 'If timber, check for flaking paint, splits, cracks and rot. Make sure that the sealant between the frames and the walls isn\'t missing or cracked.'
    },
    OutsideWallsHeader: {
        id: 'cep.claimsPage.OutsideWallsHeader',
        defaultMessage: 'Outside walls'
    },
    OutsideWallsContent: {
        id: 'cep.claimsPage.OutsideWallsContent',
        defaultMessage: 'General check for all walls: inspect brickwork for any cracks and wear (mortar falling out etc); cladding for any defects, rendering for cracks and signs of coming away from wall, tile hanging for slipped or broken tiles and any signs that gutters or downpipes have been leaking ( damp marks, mould etc.).'
    },
    // Home section - end
    // Health section - start
    HealthClaims: {
        id: 'cep.claimsPage.HealthClaims',
        defaultMessage: 'Health claims'
    },
    HealthClaimsBaseInfoP1: {
        id: 'cep.claimsPage.HealthClaimsBaseInfoP1',
        defaultMessage: 'Click \'Read more\' for step-by-step details to guide you through the process of making a claim.'
    },
    HealthMakingAClaim: {
        id: 'cep.claimsPage.HealthMakingAClaim',
        defaultMessage: 'Making a claim on your main health insurance'
    },
    HealthStep1Header: {
        id: 'cep.claimsPage.HealthStep1Header',
        defaultMessage: 'Step One'
    },
    HealthStep2Header: {
        id: 'cep.claimsPage.HealthStep2Header',
        defaultMessage: 'Step Two'
    },
    HealthStep3Header: {
        id: 'cep.claimsPage.HealthStep3Header',
        defaultMessage: 'Step Three'
    },
    HealthStep4Header: {
        id: 'cep.claimsPage.HealthStep4Header',
        defaultMessage: 'Step Four'
    },
    HealthStep5Header: {
        id: 'cep.claimsPage.HealthStep5Header',
        defaultMessage: 'Step Five'
    },
    HealthStep6Header: {
        id: 'cep.claimsPage.HealthStep6Header',
        defaultMessage: 'Step Six'
    },
    // Health claim - start
    HealthClaimStep1HeaderP1: {
        id: 'cep.claimsPage.HealthClaimStep1HeaderP1',
        defaultMessage: 'Being referred for treatment'
    },
    HealthHealthClaimStep1P1: {
        id: 'cep.claimsPage.HealthHealthClaimStep1P1',
        defaultMessage: 'Your consultation or treatment must follow an initial referral by a GP (including via a digital GP service) or dentist or another healthcare practitioner. The situations in which we will accept such a referral are set out on '
    },
    BupaWebsite: {
        id: 'cep.claimsPage.BupaWebsite',
        defaultMessage: ' Bupa\'s website'
    },
    HealthHealthClaimStep1P3: {
        id: 'cep.claimsPage.HealthHealthClaimStep1P3',
        defaultMessage: 'For muscle, bone or joint pain, see the ‘MSK Direct Access’ explanation on this page.'
    },
    HealthHealthClaimStep2P1: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P1',
        defaultMessage: 'You need to call us on {phoneNumber} or you can contact us digitally by visiting '
    },
    HealthHealthClaimStep2P1_2: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P1_2',
        defaultMessage: ' or downloading the '
    },
    HealthHealthClaimStep2P1_3: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P1_3',
        defaultMessage: 'Bupa Touch App'
    },
    HealthHealthClaimStep2P2: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P2',
        defaultMessage: 'To help us make the claims process as simple and swift as possible, please have the following information close to hand when you call us:'
    },
    HealthHealthClaimStep2P3: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P3',
        defaultMessage: 'your policy number'
    },
    HealthHealthClaimStep2P4: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P4',
        defaultMessage: 'details of the condition you are suffering from'
    },
    HealthHealthClaimStep2P5: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P5',
        defaultMessage: 'details of when your symptoms first began'
    },
    HealthHealthClaimStep2P6: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P6',
        defaultMessage: 'details of when you first consulted a GP about your condition'
    },
    HealthHealthClaimStep2P7: {
        id: 'cep.claimsPage.HealthHealthClaimStep2P7',
        defaultMessage: 'details of the treatment that has been recommended.'
    },
    HealthHealthClaimStep3P1: {
        id: 'cep.claimsPage.HealthHealthClaimStep3P1',
        defaultMessage: 'We will explain which nearby specialists, facilities and healthcare professionals are available under your benefits and provide you with a pre-authorisation number so your healthcare provider can send the bill directly to us.'
    },
    HealthHealthClaimStep3P2: {
        id: 'cep.claimsPage.HealthHealthClaimStep3P2',
        defaultMessage: 'If your specialist recommends further tests or treatment, it is important you check back with us to obtain further pre-authorisation.'
    },
    HealthHealthClaimStep3P3: {
        id: 'cep.claimsPage.HealthHealthClaimStep3P3',
        defaultMessage: 'We strongly advise you to call us before arranging or receiving any treatment to pre-authorise it, as you will be responsible for paying any fees or charges that are not covered under your benefits.'
    },
    HealthHealthClaimStep4P1: {
        id: 'cep.claimsPage.HealthHealthClaimStep4P1',
        defaultMessage: 'Usually, we will pay the providers of your treatment directly'
    },
    HealthHealthClaimStep4P2: {
        id: 'cep.claimsPage.HealthHealthClaimStep4P2',
        defaultMessage: 'Please send any correspondence to: Bupa Claims, Bupa Place, 102 The Quays, Salford M50 3SP.'
    },
    // Health claim - end
    // Health FixFastTrack - start
    HealthGuidedCareClaimsHeader: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsHeader',
        defaultMessage: 'Guided care claims'
    },
    HealthGuidedCareClaimsHeaderP1: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsHeaderP1',
        defaultMessage: 'Being referred for treatment'
    },
    HealthGuidedCareClaimsStep1P1: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep1P1',
        defaultMessage: 'Your consultation or treatment must follow an initial referral by a GP (including via a digital GP service) or dentist or another healthcare practitioner. The situations in which we will accept such a referral are set out on '
    },
    HealthGuidedCareClaimsStep1P2: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep1P2',
        defaultMessage: 'For muscle, bone or joint pain, see the ‘MSK Direct Access’ explanation on this page.'
    },
    HealthGuidedCareClaimsStep2P2: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P2',
        defaultMessage: 'To help us make the claims process as simple and swift as possible, please have the following information close to hand when you call us:'
    },
    HealthGuidedCareClaimsStep2P3: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P3',
        defaultMessage: 'your policy number'
    },
    HealthGuidedCareClaimsStep2P4: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P4',
        defaultMessage: 'details of the condition you are suffering from'
    },
    HealthGuidedCareClaimsStep2P5: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P5',
        defaultMessage: 'details of when your symptoms first began'
    },
    HealthGuidedCareClaimsStep2P6: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P6',
        defaultMessage: 'details of when you first consulted a GP about your condition'
    },
    HealthGuidedCareClaimsStep2P7: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep2P7',
        defaultMessage: 'details of the treatment that has been recommended.'
    },
    HealthGuidedCareClaimsStep3P1: {
        id: 'cep.claimsPage.HealthFixFastTrackStep3P1',
        defaultMessage: 'We will explain which nearby specialists, facilities and healthcare professionals are available under your benefits and provide you with a pre-authorisation number so your healthcare provider can send the bill directly to us.'
    },
    HealthGuidedCareClaimsStep3P2: {
        id: 'cep.claimsPage.HealthFixFastTrackStep3P2',
        defaultMessage: 'If your specialist recommends further tests or treatment, it is important you check back with us to obtain further pre-authorisation.'
    },
    HealthGuidedCareClaimsStep3P3: {
        id: 'cep.claimsPage.HealthFixFastTrackStep3P3',
        defaultMessage: 'We strongly advise you to call us before arranging or receiving any treatment to pre-authorise it, as you will be responsible for paying any fees or charges that are not covered under your benefits.'
    },
    HealthGuidedCareClaimsStep4P1: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep4P1',
        defaultMessage: 'Usually, we will pay the providers of your treatment directly'
    },
    HealthGuidedCareClaimsStep4P2: {
        id: 'cep.claimsPage.HealthGuidedCareClaimsStep4P2',
        defaultMessage: 'Please send any correspondence to: Bupa Claims, Bupa Place, 102 The Quays, Salford M50 3SP.'
    },
    // Health FixFastTrack - end
    // Health WorkingBody - start
    HealthCashBenefitHeader: {
        id: 'cep.claimsPage.HealthCashBenefitHeader',
        defaultMessage: 'Health Cash Benefit claims'
    },
    HealthCashBenefitP1: {
        id: 'cep.claimsPage.HealthCashBenefitP1',
        defaultMessage: 'If your policy started or renewed on or after 1 December 2023 and you want to claim on your Health Cash Benefits Cover, follow these steps:'
    },
    DentalClaimsHeader: {
        id: 'cep.claimsPage.DentalClaimsHeader',
        defaultMessage: 'Dental claims'
    },
    DentalClaimsP1: {
        id: 'cep.claimsPage.DentalClaimsP1',
        defaultMessage: 'To claim on the dental element of you Health Cash Benefits Cover, please {link} and follow the instructions.'
    },
    DentalClaimsP1LinkText: {
        id: 'cep.claimsPage.DentalClaimsP1LinkText',
        defaultMessage: 'download the claim form'
    },
    // Health WorkingBody - end
    // Health HealthClaimsFAQ - start
    AllOtherClaimsHeader: {
        id: 'cep.claimsPage.AllOtherClaimsHeader',
        defaultMessage: 'All other claims'
    },
    AllOtherClaimsP1: {
        id: 'cep.claimsPage.AllOtherClaimsP1',
        defaultMessage: 'For all the other elements of your Health Cash Benefits cover a claim form is not required. Instead, we just require a receipt or invoice that shows the following details:'
    },
    AllOtherClaimsP2: {
        id: 'cep.claimsPage.AllOtherClaimsP2',
        defaultMessage: 'name of the person receiving treatment'
    },
    AllOtherClaimsP3: {
        id: 'cep.claimsPage.AllOtherClaimsP3',
        defaultMessage: 'date treatment took place'
    },
    AllOtherClaimsP4: {
        id: 'cep.claimsPage.AllOtherClaimsP4',
        defaultMessage: 'details of treatment received including cost of each'
    },
    AllOtherClaimsP5: {
        id: 'cep.claimsPage.AllOtherClaimsP5',
        defaultMessage: 'the service provider name'
    },
    AllOtherClaimsP6: {
        id: 'cep.claimsPage.AllOtherClaimsP6',
        defaultMessage: 'proof that you paid for the treatment'
    },
    AllOtherClaimsP7: {
        id: 'cep.claimsPage.AllOtherClaimsP7',
        defaultMessage: 'Please send all correspondence (including your name and policy number) to:'
    },
    AllOtherClaimsP8: {
        id: 'cep.claimsPage.AllOtherClaimsP8',
        defaultMessage: 'Bupa Claims, Bupa Place, 102 The Quays, Salford M50 3SP.'
    },
    MSKDirectHeader: {
        id: 'cep.claimsPage.MSKDirectHeader',
        defaultMessage: 'MSK Direct Access'
    },
    MSKDirectP1: {
        id: 'cep.claimsPage.MSKDirectP1',
        defaultMessage: 'When you experience muscle, bone or joint pain, it is important that you get the most appropriate support early. With ‘MSK Direct Access’ you can get access to advice and treatment without the need for a GP referral.'
    },
    MSKDirectP2: {
        id: 'cep.claimsPage.MSKDirectP2',
        defaultMessage: 'If you develop a problem, call the Bupa helpline on {phoneNumber}, so they can first check your cover and then offer a free telephone or video physiotherapist assessment, within 48 hours.'
    },
    HealthFaqHeader: {
        id: 'cep.claimsPage.HealthFaqHeader',
        defaultMessage: 'Health claims FAQs'
    },
    AnytimeHealthLineHeader: {
        id: 'cep.claimsPage.AnytimeHealthLineHeader',
        defaultMessage: 'Anytime HealthLine'
    },
    AnytimeHealthLineP1: {
        id: 'cep.claimsPage.AnytimeHealthLineP1',
        defaultMessage: 'With the Anytime HealthLine you have access to a qualified nursing team 24 hours a day, 365 days a year.'
    },
    AnytimeHealthLineP2: {
        id: 'cep.claimsPage.AnytimeHealthLineP2',
        defaultMessage: 'Our qualified nursing team is on hand to give you the benefit of their expertise. They can answer your questions and give you all the latest information on specific illnesses, treatments and medications as well as details of local and national organisations.'
    },
    AnytimeHealthLineP3: {
        id: 'cep.claimsPage.AnytimeHealthLineP3',
        defaultMessage: 'The Anytime HealthLine is available to you any time – day or night, 365 days a year'
    },
    AnytimeHealthLineP4: {
        id: 'cep.claimsPage.AnytimeHealthLineP4',
        defaultMessage: 'Call {phoneNumber}'
    },
    AnytimeHealthLineP5: {
        id: 'cep.claimsPage.AnytimeHealthLineP5',
        defaultMessage: 'Please remember to have your policy number to hand before you call.'
    },
    HealthFaqP1: {
        id: 'cep.claimsPage.HealthFaqP1',
        defaultMessage: 'We know it can be hard to take everything in when you’re worried about your health, so here are the answers to some of the most common questions our customers have.'
    },
    HealthFaqQ1: {
        id: 'cep.claimsPage.HealthFaqQ1',
        defaultMessage: 'What\'s an excess?'
    },
    HealthFaqA1: {
        id: 'cep.claimsPage.HealthFaqA1',
        defaultMessage: 'This is the amount you’ve chosen to contribute towards your treatments. You’ll only pay this once a year for each person who claims. Having an excess lowers your premium.'
    },
    HealthFaqQ2: {
        id: 'cep.claimsPage.HealthFaqQ2',
        defaultMessage: 'What is a ‘4-week’ or a ‘6-week’ rule?'
    },
    HealthFaqA2: {
        id: 'cep.claimsPage.HealthFaqA2',
        defaultMessage: 'If the procedure or invasive diagnostic test is not available for you through the NHS within four or six weeks of when you need it, depending on the option you\'ve selected, we’ll get you seen privately. You’ll have chosen this to lower your premium when you signed up to your Saga plan.'
    },
    HealthFaqQ3: {
        id: 'cep.claimsPage.HealthFaqQ3',
        defaultMessage: 'What is a No Claim Discount (NCD)?'
    },
    HealthFaqA3P1: {
        id: 'cep.claimsPage.HealthFaqA3P1',
        defaultMessage: 'This is a discount added to your policy each year based on your claims history. The No Claim Discount rises annually by 5% to a maximum of 60% if no claims are made. (Please see your '
    },
    HealthFaqA3P2: {
        id: 'cep.claimsPage.HealthFaqA3P2',
        defaultMessage: ' for more information on NCD).'
    },
    HealthFaqQ4: {
        id: 'cep.claimsPage.HealthFaqQ4',
        defaultMessage: 'How is the No Claim Discount (NCD) calculated?'
    },
    HealthFaqQ4A1: {
        id: 'cep.claimsPage.HealthFaqA4',
        defaultMessage: 'Your current NCD level is shown on your Policy Schedule. This is how the NCD level is calculated:'
    },
    HealthFaqQ4A2: {
        id: 'cep.claimsPage.HealthFaqA5',
        defaultMessage: '<b>Where nobody covered on the policy makes a claim</b> - The NCD for the policy is increased by one level at the following policy renewal date until level 10 is reached'
    },
    HealthFaqQ4A3: {
        id: 'cep.claimsPage.HealthFaqQ5A1',
        defaultMessage: '<b>For each claim made on the policy</b> - The NCD for the policy is reduced by two levels at the following policy renewal date for each claim made until level 0 is reached.'
    },
    HealthFaqQ4A4: {
        id: 'cep.claimsPage.HealthFaqQ5A2',
        defaultMessage: 'These are the NCD levels and their discount percentage on a basic premium rate:'
    },
    HealthFaqQ4A4P1: {
        id: 'cep.claimsPage.HealthFaqQ4A4P1',
        defaultMessage: 'Level 0 = 0%'
    },
    HealthFaqQ4A4P2: {
        id: 'cep.claimsPage.HealthFaqQ4A4P2',
        defaultMessage: 'Level 1 = 10%'
    },
    HealthFaqQ4A4P3: {
        id: 'cep.claimsPage.HealthFaqQ4A4P3',
        defaultMessage: 'Level 2 = 20%'
    },
    HealthFaqQ4A4P4: {
        id: 'cep.claimsPage.HealthFaqQ4A4P4',
        defaultMessage: 'Level 3 = 25%'
    },
    HealthFaqQ4A4P5: {
        id: 'cep.claimsPage.HealthFaqQ4A4P5',
        defaultMessage: 'Level 4 = 30%'
    },
    HealthFaqQ4A4P6: {
        id: 'cep.claimsPage.HealthFaqQ4A4P6',
        defaultMessage: 'Level 5 = 35%'
    },
    HealthFaqQ4A4P7: {
        id: 'cep.claimsPage.HealthFaqQ4A4P7',
        defaultMessage: 'Level 6 = 40%'
    },
    HealthFaqQ4A4P8: {
        id: 'cep.claimsPage.HealthFaqQ4A4P8',
        defaultMessage: 'Level 7 = 45%'
    },
    HealthFaqQ4A4P9: {
        id: 'cep.claimsPage.HealthFaqQ4A4P9',
        defaultMessage: 'Level 8 = 50%'
    },
    HealthFaqQ4A4P10: {
        id: 'cep.claimsPage.HealthFaqQ4A4P10',
        defaultMessage: 'Level 9 = 55%'
    },
    HealthFaqQ4A4P11: {
        id: 'cep.claimsPage.HealthFaqQ4A4P11',
        defaultMessage: 'Level 10 = 60%'
    },
    // HealthFaqA4 - answer in a form of a image
    HealthFaqQ5: {
        id: 'cep.claimsPage.HealthFaqQ5',
        defaultMessage: 'Can I make a claim online?'
    },
    HealthFaqA5P1: {
        id: 'cep.claimsPage.HealthFaqA5P1',
        defaultMessage: 'You can create an account online by visiting {link1} or download the {link2}. From here you can call or use Webchat to get in touch, pre-authorise treatment and view your claims history.'
    },
    HealthFaqA5Link1: {
        id: 'cep.claimsPage.HealthFaqA5Link1',
        defaultMessage: 'Bupa online'
    },
    HealthFaqA5Link2: {
        id: 'cep.claimsPage.HealthFaqA5Link2',
        defaultMessage: 'Bupa Touch App'
    },
    HealthFaqA5P2: {
        id: 'cep.claimsPage.HealthFaqA5P2',
        defaultMessage: ' treatment online. You can also check the progress of claims you’ve made, upload documents and invoices, update your details and message us about your policy. It’s easy to use, secure and personal to you.'
    },
    HealthFaqQ6: {
        id: 'cep.claimsPage.HealthFaqQ6',
        defaultMessage: 'Do I have to pay for my treatment?'
    },
    HealthFaqA6P1: {
        id: 'cep.claimsPage.HealthFaqA6P1',
        defaultMessage: 'Not if you see one of our fee-assured specialists and your treatment is covered by your policy. If you choose a specialist that is not approved by us, or one that charges more than our approved fee limits, you may have to pay some or all of your treatment costs yourself. Check your '
    },
    HealthFaqA6P2: {
        id: 'cep.claimsPage.HealthFaqA6P2',
        defaultMessage: ' for more details on treatments and what is and isn’t covered by your policy.'
    },
    // Health HealthClaimsFAQs - end
    HealthPolicyBook: {
        id: 'cep.claimsPage.HealthPolicyBook',
        defaultMessage: 'Policy Book'
    },
    HealthClaimOrPreAuthoriseTreatmentOnline: {
        id: 'cep.claimsPage.HealthClaimOrPreAuthoriseTreatmentOnline',
        defaultMessage: 'claim or pre-authorise treatment online'
    },
    HealthSagaGpService: {
        id: 'cep.claimsPage.HealthSagaGpService',
        defaultMessage: 'Saga GP Service'
    },
    // Health section - end
    // Travel section - start
    TravelClaims: {
        id: 'cep.claimsPage.TravelClaims',
        defaultMessage: 'Travel claims'
    },
    TravelClaimsBaseInfoP1: {
        id: 'cep.claimsPage.TravelClaimsBaseInfoP1',
        defaultMessage: 'Whatever the reason for your claim, you can either claim online or call us so we can assist you through the process.'
    },
    TravelSpecialistTeam: {
        id: 'cep.claimsPage.TravelSpecialistTeam',
        defaultMessage: 'Our specialist team is there to offer you the personal touch, when you need it most.'
    },
    TravelMedicalHelp: {
        id: 'cep.claimsPage.TravelMedicalHelp',
        defaultMessage: 'I need medical help or repatriation'
    },
    TravelLostOrStolenPassportHelp: {
        id: 'cep.claimsPage.TravelLostOrStolenHelp',
        defaultMessage: 'Lost or stolen passport'
    },
    TravelLostOrStolenBelongingsHelp: {
        id: 'cep.claimsPage.TravelLostOrStolenBelongingsHelp',
        defaultMessage: 'Lost or stolen belongings'
    },
    TravelSelectClaimsHelp: {
        id: 'cep.claimsPage.TravelSelectClaimsHelp',
        defaultMessage: 'Select travel insurance claims'
    },
    TravelCancellationHelp: {
        id: 'cep.claimsPage.TravelCancellationHelp',
        defaultMessage: 'Cancellation and all other claims'
    },
    TravelClaimOnlineOrCall: {
        id: 'cep.claimsPage.TravelClaimOnlineOrCall',
        defaultMessage: ' or call {phoneNumberFirst} or {phoneNumberSecond}'
    },
    TravelClaimOnline: {
        id: 'cep.claimsPage.TravelClaimOnline',
        defaultMessage: 'Claim online'
    },
    TravelOrCall: {
        id: 'cep.claimsPage.TravelOrCall',
        defaultMessage: ' or call '
    },
    TravelOr: {
        id: 'cep.claimsPage.TravelOr',
        defaultMessage: ' or '
    }
});
